<template>
  <div class="card card-profile card-search shadow">
    <my-spinner :loading="loading" />

    <div class="card-body">
      <v-select
        label="nombre_fantasia"
        :on-search="setList"
        :options="clientstmp"
        :filterable="false"
        style="width: 100%"
        v-model="client_"
        @input="getDealer"
        placeholder="Buscar por nombre, código, rut o identifier"
        :disabled="loading"
      >
        <span slot="no-options">No hay resultados disponibles</span>
      </v-select>
    </div>
  </div>
</template>
<script>
import _ from "underscore";
import utils from "@/helpers/utils";
import vSelect from "vue-select";
import sysMsgs from "@/helpers/system.message";
import clientesServices from "@/services/dealers.services";
export default {
  name: "SearchDealer",
  components: {
    vSelect,
  },
  props: [
    'inputData',
    'options',
  ],
  data() {
    return {
      loading: false,
      client_: null,
      client: null,
      clientstmp: [],
      clients: [],
    };
  },
  watch: {
    client_: {
      deep: true,
      handler(data) {
        if (data == null) {
          this.clientstmp = this.clients;
          return false;
        }
      },
    },
  },
  created() {
    this.getAllDealers();
  },
  methods: {
    getAllDealers() {
      this.loading = true;
      clientesServices.general
        .getAll(utils.jsonToQueryString(this.options))
        .then((response) => {
          this.clients = response.data.dealers;
          this.clientstmp = this.clients;
          this.$emit('onChangeNetsuite', (this.clients.length > 0 && this.clients[0].netsuite === true));
        })
        .catch((error) => {
          sysMsgs.getResponseMessage(error.response);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getDealer(value) {
      if (!value) return this.$emit("update:inputData", null);
      this.$emit("update:inputData", value);
    },
    setList(search, loading) {
      search = search.toString().trim().toLowerCase();
      if (search.length > 0) {
        this.clientstmp = _.filter(this.clients, (filter) => {
          if (!isNaN(search)) {
            return (
              filter.cod_cliente.toString() === search ||
              filter.rut
                .toString()
                .toLowerCase()
                .startsWith(this.replaceCharactersRut(search))
            );
          }

          return (
            filter.nombre_fantasia.toString().toLowerCase().indexOf(search) >
              -1 ||
            filter.identifier.toString().toLowerCase().indexOf(search) > -1 ||
            filter.rut
              .toString()
              .toLowerCase()
              .startsWith(this.replaceCharactersRut(search))
          );
        });
      } else {
        this.clientstmp = this.clients;
      }
    },
    replaceCharactersRut(rut) {
      if (rut.toString().length > 3) {
        return rut.toString().toLowerCase().replace(/[.]/g, "");
      }
      return rut;
    },
    clean() {
      this.client_ = null;
    },
  },
};
</script>